import { gql } from "@apollo/client";

export const GET_CAROUSEL_INFO = gql`
  query {
    getCurrentPromos {
      orderId
      startTime
      endTime
      cmsTag
      list {
        cta
        linkTo
        imageDesktop
        imageTablet
        imageMobile
      }
    }
  }
`;
